import { Typography } from 'antd';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { useQuoteDeliveryStatusStyles } from './QuoteDeliveryStatus.styles';

export const DeliveryStatus = ({ className, flightStatus }) => {
  const { styles } = useQuoteDeliveryStatusStyles();
  return (
    <Typography.Text className={classNames(className, styles.itineraryLabel)}>
      <FormattedMessage id="book.quote.flightInformation.status" />
      <span className={styles.itineraryStatus}>
        {flightStatus || (
          <FormattedMessage id="book.quote.flightInformation.status.onTime" />
        )}
      </span>
    </Typography.Text>
  );
};
